import React, { useState } from 'react'
import "./Newsletter.css"

import { Container, Row, Col, Form, FormGroup } from 'reactstrap'
import MaleTourist from "../assets/images/male-tourist.png"
import { BASE_URL } from '../utils/config'


const Newsletter = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const submitHandler = async (e) => {
        e.preventDefault();
        if (!email) return;

        try {
            const res = await fetch(`${BASE_URL}/newsletter`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email })
            });
            const result = await res.json();
            if (res.ok) {
                setMessage("Subscribed successfully!");
                setEmail('');
            } else {
                setMessage(result.message || "Subscription failed");
            }
        } catch (err) {
            setMessage("Something went wrong");
        }
    }

    return (
        <section className='newsletter'>
            <Container>
                <Row>
                    <Col lg="6">
                        <div className="newsletter__content">
                            <h2>Subscribe to get Useful Traveling Information</h2>

                            <div className="newsletter__input">
                                <input
                                    type="email"
                                    placeholder='Enter Your Email'
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                                <button className='btn newsletter__btn' onClick={submitHandler}>Subscribe</button>
                            </div>
                            {message && <p className="mt-2 text-white">{message}</p>}

                            <p>Get exclusive travel tips, hidden gems, and special offers delivered directly to your inbox. Join our community of travelers today!
                            </p>
                        </div>
                    </Col>
                    <Col lg="6">
                        <div className="newsletter__img">
                            <img src={MaleTourist} alt="" />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Newsletter